import {
  AuthService,
  CustomButton,
  CustomLabel,
  FlexContainer,
  ModalComponent,
  RedButton,
  ToastService,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import React, { ReactNode } from "react";
import { InvoiceStatus } from "../../../shared/enums";
import { ContactReferenceModel } from "../../../shared/models";
import { InvoiceUtil } from "../../../shared/utils";
import {  InvoiceService } from "../../../shared/services";
import { AccountSettingsStore } from "../../../shared/store";

type Props = {
  onClose: (deleted: boolean) => void;
  id: string;
  status: keyof typeof InvoiceStatus;
  contact: ContactReferenceModel;
  invoiceNumber: string;
  balance: number;
  dueDate: Date;
};
const DeleteInvoicePopUp: React.FC<Props> = ({
  onClose,
  invoiceNumber,
  status,
  id,
  contact,
  balance,
  dueDate,
}) => {
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);
  function row(label: string, rightContent: ReactNode) {
    return (
      <FlexContainer alignItems="center" spacing={20}>
        <CustomLabel> {label}</CustomLabel>
        {rightContent}
      </FlexContainer>
    );
  }

  function body() {
    const colors = InvoiceUtil.getColorsByStatus(status);
    return (
      <FlexContainer fxLayout="column" justifyContent="center" spacing={10}>
        <CustomLabel>
          Do you want to{" "}
          <CustomLabel color="#FF0000" fontWeight={600}>
            permanently delete
          </CustomLabel>{" "}
          this Invoice?
        </CustomLabel>
        {row(
          "Customer",
          <CustomLabel> {contact.fullName || contact.email}</CustomLabel>
        )}
        {row("Invoice No", <CustomLabel> {invoiceNumber}</CustomLabel>)}
        {row(
          "Status",
          <CustomButton color={colors.color} bgColor={colors.bgColor}>
            {InvoiceStatus[status]}
          </CustomButton>
        )}
        {row(
          "Balance Due",
          <CustomLabel fontWeight={600}>
            ${AccountSettingsStore.formatAmount(balance)}
          </CustomLabel>
        )}
        {row(
          "Payment Due",
          <CustomLabel fontWeight={600}>
            {UtilityMethods.formatDateInString(dueDate)}
          </CustomLabel>
        )}

        <CustomLabel color="#FF0000">
          Deleting a {InvoiceStatus[status]} Invoice will permanently remove it.
        </CustomLabel>
      </FlexContainer>
    );
  }

  function onDelete() {
    if (isAPIRequestPending) return;

    setAPIRequestPending(true);
    InvoiceService.deleteInvoice(AuthService.authData.accountId, id).subscribe({
      next: (response) => {
        setAPIRequestPending(false);
        if (response.result.success) {
          ToastService.showSuccess("Invoice Cancelled Successfully");
        }

        ToastService.showSuccess("Invoice Deleted Successfully");
        onClose(true);
      },
      error: () => {
        setAPIRequestPending(false);
        ToastService.showError("Error in deleting invoice");
      },
    });
  }

  return (
    <ModalComponent
      title="Delete Invoice"
      titleFontSize="22px"
      bodyPadding="50px 61px"
      showFooter={true}
      minHeight="240px"
      wrapperWidth="550px"
      bodyBackgroundColor="#fefefe"
      footerBackground="#F4F7FB"
      footerHeight="auto"
      redHeader={true}
      blueHeader={false}
      onClose={() => onClose(false)}
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <RedButton
            disabled={isAPIRequestPending}
            minWidth="120px"
            height="40px"
            onClick={() => onDelete()}
          >
            Delete
          </RedButton>
          <RedButton
            primary
            minWidth="120px"
            height="40px"
            onClick={() => onClose(false)}
          >
            Do Not Delete
          </RedButton>
        </FlexContainer>
      }
    >
      {body()}
    </ModalComponent>
  );
};

export default DeleteInvoicePopUp;
